import React, { useState } from 'react';
import PaginatedTable from '../Shared/PaginatedTable';
import FilterIcon from '../../SVG/Filter';
import { useAuth } from "../../src/Context/AuthContext"

const RegisteredSearchSection = () => {
    //State Variables
    const [searchParams, setSearchParams] = useState({
        firstName: '',
        lastName: '',
        email: '',
        lastFour: '',
        agentCode: '',
    });
    const [results, setResults] = useState([]);
    const [noItemsFound, setNoItemsFound] = useState(false);
    const { logout } = useAuth();

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;

    const handleChange = (e) => {
        setSearchParams({ ...searchParams, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiURL}/admin/search/registrationAttempts?${new URLSearchParams(searchParams)}`, {
                method: "GET",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");

            }
            if (res.status === 404) {
                // No items found (API should return 404 in this case)
                setResults([]); // Clear results if needed
                setNoItemsFound(true); // Custom state to show message
                return;
            }

            if (!res.ok) {
                const text = await res.text(); // log raw error response
                throw new Error(`Request failed: ${res.status} ${res.statusText}\n${text}`);
            }

            const data = await res.json();
            setResults(data);
            setNoItemsFound(data.length === 0);
        } catch (err) {
            console.error("Fetch error:", err.message);
            alert("An error occurred while fetching data. Check the console for details.");
        }
    };

    //Table Info
    const columns = [
        { label: 'First Name', accessor: 'firstName' },
        { label: 'Last Name', accessor: 'lastName' },
        { label: 'Email', accessor: 'email' },
        { label: 'Username', accessor: 'userName' },
        { label: 'Last 4 SSN', accessor: 'lastFour' },
        { label: 'DOB', accessor: 'birthDate' },
        { label: 'AgentCode', accessor: 'agentCode' },
        { label: 'Attempt Date', accessor: 'transactionDate' },
        { label: 'Last Login', accessor: 'lastLogin' },
        { label: 'Success', accessor: 'success' },
        { label: 'ErrorCode', accessor: 'errorCode', hover: 'errorCodeDesc'},
    ];

    return (
        <div className="admin-materials-page">
           
            <form className="filter-box" onSubmit={handleSubmit}>
                <FilterIcon />
                <div className="filter-item">
                    <label className="filterLabel">First Name</label>
                    <input type="text" name="firstName" placeholder="e.g. John" className="filterInput" value={searchParams.firstName} onChange={handleChange} />
                </div>
                <div className="filter-item">
                    <label className="filterLabel">Last Name</label>
                    <input type="text" name="lastName" placeholder="e.g. Smith" className="filterInput" value={searchParams.lastName} onChange={handleChange} />
                </div>
                <div className="filter-item">
                    <label className="filterLabel">Email</label>
                    <input type="email" name="email" placeholder="e.g. JohnSmith@email.com" className="filterInput" value={searchParams.email} onChange={handleChange} />
                </div>
                <div className="filter-item">
                    <label className="filterLabel">Last 4 SSN</label>
                    <input type="text" name="lastFour" placeholder="e.g. 1234" maxLength={4} className="filterInput" value={searchParams.lastFour} onChange={handleChange} />
                </div>
                <div className="filter-item">
                    <label className="filterLabel">Agent Code</label>
                    <input type="text" name="agentCode" placeholder="e.g. 000001" className="filterInput" value={searchParams.agentCode} onChange={handleChange} />
                </div>

                <div className="filter-button-box">
                    <button type="submit" className="filterButton">Search</button>
                </div>
            </form>

            {noItemsFound && (
                <div className="no-items-message">
                    No registration attempts found.
                </div>
            )}
            {results.length > 0 && (
                <PaginatedTable data={results} columns={columns} />
            )}
        </div>
    );
};

export default RegisteredSearchSection;
